<template>
  <div class="priorities">
    <div class="prefs-wrapper">
      <!-- COLOR -->
      <div class="prefs-tile" v-if="color">
        <span> {{ $t("labels.color") }}: {{ colorName }} </span>
        <i class="far fa-times" @click="removePriority(prioritiesEnum.COLOR)" />
      </div>
      <!-- PAINT FINISH -->
      <div class="prefs-tile" v-if="paintFinish">
        <span> {{ $t("labels.paintFinish") }}: {{ paintFinishName }} </span>
        <i class="far fa-times" @click="removePriority(prioritiesEnum.PAINT_FINISH)" />
      </div>
      <!-- WHEEL SIZE -->
      <div class="prefs-tile" v-if="wheelSize">
        <span> {{ $t("labels.wheelSize") }}: {{ wheelSizeName }} </span>
        <i class="far fa-times" @click="removePriority(prioritiesEnum.WHEEL_SIZE)" />
      </div>
      <!-- FRAME FABRIC -->
      <div v-if="frameFabric.length">
        <div class="prefs-tile">
          <span> {{ $t("labels.frameFabric") }}: </span>
          <span v-for="(item, index) in frameFabric" :key="index">
            {{ getFrameFabric(item) }}
          </span>
          <i class="far fa-times" @click="removePriority(prioritiesEnum.FRAME_FABRIC)" />
        </div>
      </div>
      <!-- REAR SHOCK ABSORBER -->
      <div class="prefs-tile" v-if="rearShockAbsorber">
        <span> {{ $t("labels.rearShockAbsorber") }}: {{ rearShockAbsorber }} </span>
        <i class="far fa-times" @click="removePriority(prioritiesEnum.REAR_SHOCK_ABSORBER)" />
      </div>
      <!-- GEARS NUMBER -->
      <div class="prefs-tile" v-if="gearsNumber">
        <span> {{ $t("labels.gearsNumber") }}: {{ gearsNumberName }} </span>
        <i class="far fa-times" @click="removePriority(prioritiesEnum.GEARS_NUMBER)" />
      </div>
      <!-- ELECTRIC BIKE -->
      <div class="prefs-tile" v-if="electricBike">
        <span> {{ $t("labels.electricBike") }}: {{ electricBike }} </span>
        <i class="far fa-times" @click="removePriority(prioritiesEnum.ELECTRIC_BIKE)" />
      </div>
      <!-- OPTIONAL DESTINY -->
      <div v-if="optionalDestinies.length">
        <div class="prefs-tile">
          <span> {{ $t("labels.optionalDestiny") }}: </span>
          <span v-for="(item, index) in optionalDestinies" :key="index">
            {{ getDestinyName(item) }}
          </span>
          <i class="far fa-times" @click="removePriority(prioritiesEnum.OPTIONAL_DESTINY)" />
        </div>
      </div>
      <!-- OPTIONAL AREA -->
      <div v-if="optionalAreas.length">
        <div class="prefs-tile">
          <span> {{ $t("labels.optionalArea") }}: </span>
          <span v-for="(item, index) in optionalAreas" :key="index">
            {{ getAreaName(item) }}
          </span>
          <i class="far fa-times" @click="removePriority(prioritiesEnum.OPTIONAL_AREA)" />
        </div>
      </div>
    </div>
    <div class="priorities-footer">
      <span @click="goToAdvancedFilters">{{ $t("labels.changeParameters") }}</span>
    </div>
  </div>
</template>
<script>
// vuex
import { mapFields } from "vuex-map-fields";

// css
import "./OtherPreferences.scss";

// enums
import { prioritiesEnum } from "@/enums/prioritiesEnum.js";

// methods
import updateUrlParams from "@/router/middleware/updateUrlParamsMiddleware";
import setCookie from "@/utils/setCookie";

export default {
  name: "OtherPriorities",
  data() {
    return {
      prioritiesEnum,
    };
  },
  computed: {
    ...mapFields([
      "filters.color",
      "filters.paintFinish",
      "filters.wheelSize",
      "filters.frameFabric",
      "filters.rearShockAbsorber",
      "filters.gearsNumber",
      "filters.electricBike",
      "filters.optionalDestinies",
      "filters.optionalAreas",
      "colors",
      "wheelSizes",
      "frameFabrics",
      "gearsNumbers",
      "paintFinishes",
      "areas",
      "destinies",
    ]),
    colorName() {
      if (this.colors.length) {
        return this.colors.filter((el) => el.Value === +this.color)[0].Text;
      }
      return null;
    },
    wheelSizeName() {
      if (this.wheelSizes.length) {
        return this.wheelSizes.filter((el) => el.Value === +this.wheelSize)[0].Text;
      }
      return null;
    },
    paintFinishName() {
      if (this.paintFinishes.length) {
        return this.paintFinishes.filter((el) => el.Value === +this.paintFinish)[0].Text;
      }
      return null;
    },
    gearsNumberName() {
      if (this.gearsNumbers.length) {
        return this.gearsNumbers.filter((el) => el.Value === +this.gearsNumber)[0].Text;
      }
      return null;
    },
  },
  methods: {
    removePriority(priority) {
      switch (priority) {
        case prioritiesEnum.COLOR:
          this.color = null;
          setCookie("color", null, this);
          updateUrlParams();
          break;
        case prioritiesEnum.PAINT_FINISH:
          this.paintFinish = null;
          setCookie("paintFinish", null, this);
          updateUrlParams();
          break;
        case prioritiesEnum.WHEEL_SIZE:
          this.wheelSize = null;
          setCookie("wheelSize", null, this);
          updateUrlParams();
          break;
        case prioritiesEnum.FRAME_FABRIC:
          this.frameFabric = [];
          setCookie("frameFabric", null, this);
          updateUrlParams();
          break;
        case prioritiesEnum.REAR_SHOCK_ABSORBER:
          this.rearShockAbsorber = null;
          setCookie("rearShockAbsorber", null, this);
          updateUrlParams();
          break;
        case prioritiesEnum.GEARS_NUMBER:
          this.gearsNumber = null;
          setCookie("gearsNumber", null, this);
          updateUrlParams();
          break;
        case prioritiesEnum.ELECTRIC_BIKE:
          this.electricBike = null;
          setCookie("electricBike", null, this);
          updateUrlParams();
          break;
        case prioritiesEnum.OPTIONAL_DESTINY:
          this.optionalDestinies = [];
          setCookie("optionalDestinies", null, this);
          updateUrlParams();
          break;
        case prioritiesEnum.OPTIONAL_AREA:
          this.optionalAreas = [];
          setCookie("optionalAreas", null, this);
          updateUrlParams();
      }
    },
    goToAdvancedFilters() {
      this.$router.push({
        name: "secondStepWithFilters",
      });
    },
    getDestinyName(index) {
      return this.destinies.filter((el) => el.Value === +index)[0].Text;
    },
    getAreaName(index) {
      return this.areas.filter((el) => el.Value === +index)[0].Text;
    },
    getFrameFabric(index) {
      return this.frameFabrics.filter((el) => el.Value === +index)[0].Text;
    },
  },
};
</script>
